import { GridStateCommunity } from '../../../models/gridStateCommunity'
import { GridReactTableInstance } from '../../../models/gridReactTable'
import { DataGridProcessedProps } from '../../../models/props/DataGridProps'

export const gridTotalHeaderHeightSelector = ({
  state,
  tableInstance,
  props,
}: {
  state: GridStateCommunity
  tableInstance: GridReactTableInstance
  props: Pick<DataGridProcessedProps, 'showColumnGrouping' | 'hideColumnHeader'>
}) => {
  if (props.hideColumnHeader) {
    return 0
  } else if (props.showColumnGrouping) {
    return state.density.headerHeight * tableInstance.getHeaderGroups().length
  } else {
    return state.density.headerHeight
  }
}
